import type { FieldViewProps, ValueState } from '../../types'
import type SelectController from './Controller'

import { useMemo } from 'react'
import { format, isValid } from 'date-fns'

import { Calendar } from '@/shared/components/ui/calendar'
import { getDatesLocale } from '@/shared/i18n'

import PopoverFooter from '../../components/PopoverFooter'

type SelectViewProps = FieldViewProps<SelectController> & {
	localValue: ValueState<string[]>
}

export default function DateRangeView({
	field,
	isDirty,
	isRemovable,
	localValue,
	onChange,
	onRemove,
	onApply,
	closePopup,
}: SelectViewProps) {
	const { operation } = localValue

	const value = useMemo(
		() => ({
			from: localValue?.value?.[0]
				? new Date(localValue?.value?.[0])
				: undefined,
			to: localValue?.value?.[1] ? new Date(localValue?.value?.[1]) : undefined,
		}),
		[localValue]
	)

	const handleChange = (value: string[]) => onChange({ operation, value })

	//handleChange
	return (
		<div className='min-w-[320px]'>
			<Calendar
				mode='range'
				locale={getDatesLocale()}
				defaultMonth={value?.from}
				selected={value}
				onSelect={(range) =>
					range
						? handleChange(
								[range.from, range.to]
									.filter((date) => !!date && isValid(date))
									.map((date) => format(date!, 'yyyy-MM-dd'))
							)
						: handleChange([])
				}
				numberOfMonths={2}
			/>
			<PopoverFooter
				isDisabledApply={!isDirty}
				onRemove={isRemovable ? onRemove : undefined}
				onApply={() => {
					onApply()
					closePopup()
				}}
			/>
		</div>
	)
}
